module.exports = __webpack_public_path__ + "static/media/mickey_esp_3002.9a92a77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/mickey_esp_3002.png
// module id = 180
// module chunks = 0